<template>
  <autocomplete
    item-value="targa"
    item-text="targa"
    :items="items"
    :loading="loading"
    :value="value"
    v-bind="$attrs"
    v-on="$listeners"/>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'UnitaMobiliSelect',
    props: {
        value: { required: false }
    },
    created () {
        this.$store.dispatch('loadUnitaMobili').catch(e => {
            this.$snackbar.showServerError(e)
        })
    },
    computed: {
        ...mapState({
            items: state => state.global.unitaMobili,
            loading: state => state.global.loading.unitaMobili
        })
    }
}
</script>
